const ContentRepository = require('./../repository/ContentRepository');
const menuMobile = require('./../../../services/structure/menu/mobile');
const Zone = require('./../../../services/structure/zone');
const Notifier = require('./../../../services/notifier');
const Translator = require('./../../../core/translator');
const Loader = require('./../../../services/loader');
const Overlay = require('./../../../services/overlay');
const Container = require('./../../../core/container');

module.exports.onCancel = () => {
    Zone.setSmallPanel(Translator.translate('cancel_publish_title'), `<p>${Translator.translate('cancel_publish_message')}</p>`);
    Zone.setFooter(Container.get('$smallPanel'), Zone.createSubmitButtons({
        onSubmitClick: function() {
            Loader.start();
            Zone.hidePanels();
            Overlay.show();
            ContentRepository.cancel().done(function(data, response) {
                Loader.stop();
                Overlay.hide();

                const rollbackCount = response.getHeader('X-Rollback-Count') || response.getHeader('X-Rollback-Count'.toLowerCase());

                if (rollbackCount > 0) {
                    window.location.reload();
                } else {
                    Notifier.warning(Translator.translate('nothing_to_cancel'), null, 'cancel-notif');
                }

                return data;
            });
        },
        onCancelClick: function() {
            menuMobile.close();
            Zone.hidePanels();
        },
    }));
};
